import { PdWizard } from "./pd-wizard/PdWizard.js";
//#region src/pd-wizard/pd-wizard.ts
var tag = "pd-wizard";
if (!customElements.get(tag)) customElements.define(tag, PdWizard);
//#endregion
export { PdWizard };
